const GeometryType = Object.freeze({
  POINT: "Point",
  LINE_STRING: "LineString",
  POLYGON: "Polygon",
  MULTI_POINT: "MultiPoint",
  MULTI_LINE_STRING: "MultiLineString",
  MULTI_POLYGON: "MultiPolygon",
  GEOMETRY_COLLECTION: "GeometryCollection"
});
export default GeometryType;